import { useState, useMemo } from 'react';
import { Bell, Check, Clock, AlertTriangle, CheckCircle, Info, ChevronLeft, ChevronRight, Package, Users, CloudRain, FileText, Wrench } from 'lucide-react';
import { Button, Card } from '@components/ui';
import clsx from 'clsx';

/**
 * Şantiye Şefi Bildirimler Sayfası
 * Şantiye odaklı bildirimler + Pagination
 */

// Daha fazla şef bildirimi
const sefBildirimleri = [
    { id: 1, type: 'personel', title: 'Yeni Personel Atandı', message: 'Ahmet Çelik şantiyenize yeni işçi olarak atandı.', date: '2026-01-18T08:30:00', isRead: false, severity: 'info' },
    { id: 2, type: 'malzeme', title: 'Malzeme Teslimatı', message: 'Çimento siparişi yarın saat 09:00\'da teslim edilecek.', date: '2026-01-18T07:00:00', isRead: false, severity: 'info' },
    { id: 3, type: 'uyari', title: 'Hava Durumu Uyarısı', message: 'Yarın için yağmur bekleniyor. Dış mekan çalışmalarını planlayın.', date: '2026-01-17T18:00:00', isRead: true, severity: 'warning' },
    { id: 4, type: 'gorev', title: 'Günlük Rapor Hatırlatması', message: 'Bugünün şantiye günlüğünü girmeyi unutmayın.', date: '2026-01-17T17:00:00', isRead: false, severity: 'warning' },
    { id: 5, type: 'onay', title: 'İş Tamamlandı', message: 'A Blok 2. kat kaba inşaat tamamlandı olarak işaretlendi.', date: '2026-01-17T16:00:00', isRead: true, severity: 'success' },
    { id: 6, type: 'malzeme', title: 'Stok Uyarısı', message: 'Demir stoku kritik seviyenin altına düştü!', date: '2026-01-16T14:30:00', isRead: false, severity: 'error' },
    { id: 7, type: 'personel', title: 'Eksik Yoklama', message: '3 personelin bugün yoklaması alınmadı.', date: '2026-01-16T09:00:00', isRead: false, severity: 'warning' },
    { id: 8, type: 'malzeme', title: 'Tuğla Teslimatı', message: 'Tuğla siparişi bugün saat 14:00\'da teslim edildi.', date: '2026-01-15T14:00:00', isRead: true, severity: 'success' },
    { id: 9, type: 'personel', title: 'İzin Talebi', message: 'Mehmet Yılmaz 3 günlük izin talep etti.', date: '2026-01-15T11:00:00', isRead: true, severity: 'info' },
    { id: 10, type: 'gorev', title: 'Haftalık Toplantı', message: 'Yarın saat 10:00\'da haftalık şantiye toplantısı yapılacak.', date: '2026-01-15T09:00:00', isRead: true, severity: 'info' },
    { id: 11, type: 'uyari', title: 'Güvenlik Kontrolü', message: 'B Blok\'ta güvenlik ekipmanı eksikliği tespit edildi.', date: '2026-01-14T16:00:00', isRead: true, severity: 'warning' },
    { id: 12, type: 'onay', title: 'Temel Tamamlandı', message: 'C Blok temel betonu başarıyla dökülüp tamamlandı.', date: '2026-01-14T15:00:00', isRead: true, severity: 'success' },
    { id: 13, type: 'malzeme', title: 'Beton Siparişi', message: '50 m³ hazır beton sipariş onaylandı, yarın teslim.', date: '2026-01-14T10:00:00', isRead: true, severity: 'info' },
    { id: 14, type: 'personel', title: 'Yeni Usta Atandı', message: 'Ali Kaya elektrik ustası olarak şantiyeye atandı.', date: '2026-01-13T08:00:00', isRead: true, severity: 'info' },
    { id: 15, type: 'uyari', title: 'Malzeme Gecikmesi', message: 'Seramik malzemesi teslimatı 2 gün gecikecek.', date: '2026-01-13T14:00:00', isRead: true, severity: 'warning' },
    { id: 16, type: 'onay', title: 'Sıva Tamamlandı', message: 'A Blok 1. kat iç sıva işleri tamamlandı.', date: '2026-01-12T17:00:00', isRead: true, severity: 'success' },
    { id: 17, type: 'gorev', title: 'Kalıp Söküm', message: 'B Blok 3. kat kalıp söküm işlemi yarın başlayacak.', date: '2026-01-12T09:00:00', isRead: true, severity: 'info' },
    { id: 18, type: 'malzeme', title: 'Demir Teslimatı', message: '10 ton inşaat demiri bugün teslim alındı.', date: '2026-01-11T13:00:00', isRead: true, severity: 'success' },
    { id: 19, type: 'personel', title: 'Personel Değişikliği', message: 'Ahmet Demir başka bir şantiyeye transfer edildi.', date: '2026-01-11T10:00:00', isRead: true, severity: 'info' },
    { id: 20, type: 'uyari', title: 'Don Uyarısı', message: 'Önümüzdeki hafta gece sıcaklıkları 0°C altına düşecek.', date: '2026-01-10T18:00:00', isRead: true, severity: 'warning' },
    { id: 21, type: 'onay', title: 'Çatı İmalat Başladı', message: 'A Blok çatı imalat çalışmaları resmen başladı.', date: '2026-01-10T08:00:00', isRead: true, severity: 'success' },
    { id: 22, type: 'malzeme', title: 'Kum Teslimatı', message: '30 ton kum stoka eklendi.', date: '2026-01-09T14:00:00', isRead: true, severity: 'info' },
    { id: 23, type: 'gorev', title: 'İş Güvenliği Eğitimi', message: 'Tüm personele yarın iş güvenliği eğitimi verilecek.', date: '2026-01-09T09:00:00', isRead: true, severity: 'info' },
    { id: 24, type: 'personel', title: '5 Yeni İşçi', message: 'Bugün 5 yeni işçi şantiyede işe başladı.', date: '2026-01-08T08:00:00', isRead: true, severity: 'info' },
    { id: 25, type: 'onay', title: 'Proje Onayı', message: 'Revize mimari proje belediye tarafından onaylandı.', date: '2026-01-07T16:00:00', isRead: true, severity: 'success' },
];

const SEVERITY_CONFIG = {
    warning: { label: 'Uyarı', color: 'warning', icon: AlertTriangle, bgClass: 'bg-warning/10', textClass: 'text-warning' },
    info: { label: 'Bilgi', color: 'info', icon: Info, bgClass: 'bg-info/10', textClass: 'text-info' },
    success: { label: 'Tamamlandı', color: 'success', icon: CheckCircle, bgClass: 'bg-success/10', textClass: 'text-success' },
    error: { label: 'Kritik', color: 'error', icon: AlertTriangle, bgClass: 'bg-error/10', textClass: 'text-error' },
};

const TYPE_ICONS = {
    personel: Users,
    malzeme: Package,
    uyari: CloudRain,
    gorev: FileText,
    onay: Check,
    default: Wrench,
};

const ITEMS_PER_PAGE = 8;

export default function SefBildirimler() {
    const [notifications, setNotifications] = useState(sefBildirimleri);
    const [filter, setFilter] = useState('all');
    const [currentPage, setCurrentPage] = useState(1);

    const filteredNotifications = useMemo(() => {
        if (filter === 'unread') return notifications.filter(n => !n.isRead);
        if (filter === 'read') return notifications.filter(n => n.isRead);
        return notifications;
    }, [notifications, filter]);

    // Pagination hesaplamaları
    const totalItems = filteredNotifications.length;
    const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE);
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;
    const paginatedNotifications = filteredNotifications.slice(startIndex, endIndex);

    const unreadCount = notifications.filter(n => !n.isRead).length;

    const markAsRead = (id) => {
        setNotifications(prev => prev.map(n => n.id === id ? { ...n, isRead: true } : n));
    };

    const markAllAsRead = () => {
        setNotifications(prev => prev.map(n => ({ ...n, isRead: true })));
    };

    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        const today = new Date();
        const isToday = date.toDateString() === today.toDateString();

        if (isToday) {
            return date.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
        }
        return date.toLocaleDateString('tr-TR', { day: 'numeric', month: 'short' });
    };

    const goToPage = (page) => {
        setCurrentPage(Math.max(1, Math.min(page, totalPages)));
    };

    // Filtre değişince sayfa 1'e dön
    const handleFilterChange = (newFilter) => {
        setFilter(newFilter);
        setCurrentPage(1);
    };

    return (
        <div className="p-4 md:p-6 space-y-6">
            {/* Header */}
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                <div>
                    <h1 className="text-2xl font-bold text-text-primary flex items-center gap-2">
                        <Bell className="text-secondary" />
                        Bildirimler
                        {unreadCount > 0 && (
                            <span className="bg-primary text-white text-sm px-2 py-0.5 rounded-full">
                                {unreadCount}
                            </span>
                        )}
                    </h1>
                    <p className="text-text-tertiary mt-1">Şantiye bildirimleri ve hatırlatmalar</p>
                </div>
                <Button variant="success" icon={<Check size={18} />} onClick={markAllAsRead}>
                    Tümünü Okundu İşaretle
                </Button>
            </div>

            {/* Filters + Info */}
            <div className="flex flex-wrap items-center justify-between gap-4">
                <div className="flex flex-wrap gap-2">
                    {[
                        { key: 'all', label: 'Tümü', count: notifications.length },
                        { key: 'unread', label: 'Okunmamış', count: unreadCount },
                        { key: 'read', label: 'Okunmuş', count: notifications.length - unreadCount },
                    ].map(f => (
                        <button
                            key={f.key}
                            onClick={() => handleFilterChange(f.key)}
                            className={clsx(
                                "px-4 py-2 rounded-lg text-sm font-medium transition-colors",
                                filter === f.key
                                    ? "bg-primary text-white"
                                    : "bg-bg-tertiary text-text-secondary hover:bg-bg-hover"
                            )}
                        >
                            {f.label}
                            <span className={clsx(
                                "ml-2 px-1.5 py-0.5 rounded text-xs",
                                filter === f.key ? "bg-white/20" : "bg-bg-secondary"
                            )}>
                                {f.count}
                            </span>
                        </button>
                    ))}
                </div>

                {/* Sayfa Bilgisi */}
                <p className="text-sm text-text-muted">
                    {totalItems > 0 ? (
                        <>
                            {startIndex + 1}-{Math.min(endIndex, totalItems)} / {totalItems} bildirim
                        </>
                    ) : (
                        '0 bildirim'
                    )}
                </p>
            </div>

            {/* Notifications List */}
            <div className="space-y-3">
                {paginatedNotifications.map((notification) => {
                    const config = SEVERITY_CONFIG[notification.severity] || SEVERITY_CONFIG.info;
                    const TypeIcon = TYPE_ICONS[notification.type] || TYPE_ICONS.default;

                    return (
                        <Card
                            key={notification.id}
                            padding="none"
                            className={clsx(
                                "overflow-hidden transition-all",
                                !notification.isRead && "ring-2 ring-primary/50"
                            )}
                        >
                            <div
                                className={clsx(
                                    "p-4 flex items-start gap-4 cursor-pointer hover:bg-bg-hover transition-colors",
                                    !notification.isRead && "bg-primary/5"
                                )}
                                onClick={() => markAsRead(notification.id)}
                            >
                                {/* Icon */}
                                <div className={clsx(
                                    "w-10 h-10 rounded-lg flex items-center justify-center shrink-0",
                                    config.bgClass
                                )}>
                                    <TypeIcon size={20} className={config.textClass} />
                                </div>

                                {/* Content */}
                                <div className="flex-1 min-w-0">
                                    <div className="flex items-start justify-between gap-2">
                                        <h3 className={clsx(
                                            "font-medium",
                                            !notification.isRead ? "text-text-primary" : "text-text-secondary"
                                        )}>
                                            {notification.title}
                                        </h3>
                                        <span className="text-xs text-text-muted shrink-0 flex items-center gap-1">
                                            <Clock size={12} />
                                            {formatDate(notification.date)}
                                        </span>
                                    </div>
                                    <p className="text-sm text-text-muted mt-1">{notification.message}</p>
                                </div>

                                {/* Unread indicator */}
                                {!notification.isRead && (
                                    <div className="w-2 h-2 bg-primary rounded-full shrink-0 mt-2" />
                                )}
                            </div>
                        </Card>
                    );
                })}
            </div>

            {paginatedNotifications.length === 0 && (
                <Card className="text-center py-12">
                    <Bell size={48} className="mx-auto text-text-muted mb-4" />
                    <p className="text-text-secondary">Bildirim bulunamadı</p>
                </Card>
            )}

            {/* Pagination */}
            {totalPages > 1 && (
                <div className="flex items-center justify-center gap-2 pt-4">
                    <Button
                        variant="ghost"
                        size="sm"
                        onClick={() => goToPage(currentPage - 1)}
                        disabled={currentPage === 1}
                        icon={<ChevronLeft size={18} />}
                    >
                        Önceki
                    </Button>

                    <div className="flex items-center gap-1">
                        {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => {
                            // Çok fazla sayfa varsa ellipsis göster
                            if (totalPages > 7) {
                                if (page === 1 || page === totalPages ||
                                    (page >= currentPage - 1 && page <= currentPage + 1)) {
                                    // Göster
                                } else if (page === currentPage - 2 || page === currentPage + 2) {
                                    return <span key={page} className="px-2 text-text-muted">...</span>;
                                } else {
                                    return null;
                                }
                            }

                            return (
                                <button
                                    key={page}
                                    onClick={() => goToPage(page)}
                                    className={clsx(
                                        "w-9 h-9 rounded-lg text-sm font-medium transition-colors",
                                        currentPage === page
                                            ? "bg-primary text-white"
                                            : "bg-bg-tertiary text-text-secondary hover:bg-bg-hover"
                                    )}
                                >
                                    {page}
                                </button>
                            );
                        })}
                    </div>

                    <Button
                        variant="ghost"
                        size="sm"
                        onClick={() => goToPage(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    >
                        Sonraki
                        <ChevronRight size={18} className="ml-1" />
                    </Button>
                </div>
            )}
        </div>
    );
}
